import { motion } from "framer-motion";
import { Coffee, Camera, Briefcase, Trees, ShoppingBag } from "lucide-react";
import { useLang } from "../lib/LanguageContext";

const ICONS = [Coffee, Camera, Briefcase, Trees, ShoppingBag];

export const Features = () => {
  const { t } = useLang();

  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 md:py-32 bg-brand-sand"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.32em] text-brand-blue font-medium">
            {t.features.eyebrow}
          </span>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight text-brand-ink">
            {t.features.title}
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {t.features.items.map((item, i) => {
            const Icon = ICONS[i] || Coffee;
            const isAccent = i === 0 || i === 2;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`feature-card-${i}`}
                className={`group p-7 md:p-8 rounded-3xl border transition-all hover:-translate-y-1 hover:shadow-xl ${
                  isAccent
                    ? "bg-brand-coffee text-brand-cream border-transparent hover:shadow-brand-coffee/20"
                    : "bg-white text-brand-ink border-brand-border hover:border-brand-blue/30 hover:shadow-brand-blue/10"
                }`}
              >
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center transition-colors ${
                    isAccent
                      ? "bg-brand-gold/20 text-brand-gold"
                      : "bg-brand-blue/10 text-brand-blue group-hover:bg-brand-blue group-hover:text-white"
                  }`}
                >
                  <Icon className="w-5 h-5" strokeWidth={1.6} />
                </div>
                <h3 className="mt-6 font-serif text-xl md:text-2xl leading-tight tracking-tight">
                  {item.title}
                </h3>
                <p
                  className={`mt-3 text-sm leading-relaxed ${
                    isAccent ? "text-brand-cream/75" : "text-brand-mocha"
                  }`}
                >
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
